import SEO from "../components/SEO";

export default function Facilities() {
    return (
      <div className="container section">
        <SEO
          title="Facilities | Sri Venkateswara Degree & PG College, Nellore"
          description="Discover campus facilities at Sri Venkateswara College, Nellore: Library, Hostels, WiFi, Seminar Hall, Sports, and more."
        />
        <h2 className="text-3xl md:text-4xl font-semibold text-neutral-900">Facilities</h2>

        <section className="mt-6 grid md:grid-cols-2 gap-6">
          <div className="card p-6">
            <h3 className="text-xl font-semibold text-neutral-900">Library</h3>
            <p className="mt-2 text-neutral-700">Digital Library & Study material available</p>
          </div>
          <div className="card p-6">
            <h3 className="text-xl font-semibold text-neutral-900">Hostel</h3>
            <p className="mt-2 text-neutral-700">Free Hostel available for Boys & Girls</p>
          </div>
          <div className="card p-6">
            <h3 className="text-xl font-semibold text-neutral-900">Internet</h3>
            <p className="mt-2 text-neutral-700">WiFi Available</p>
          </div>
          <div className="card p-6">
            <h3 className="text-xl font-semibold text-neutral-900">Auditorium</h3>
            <p className="mt-2 text-neutral-700">Seminar Hall Available</p>
          </div>
        </section>

        <section className="mt-12">
          <h3 className="text-2xl font-semibold text-neutral-900 text-center">Infrastructure</h3>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              'Mushroom Cultivation',
              '24X7 Security',
              'Administrative Wing',
              'Book Stall',
              'Botanical Garden',
              'Botany and Zoology Museum',
              'CCTV',
              'Games Sports',
              'Class Rooms',
              'College Building',
              'College Canteen',
              'Cultural',
            ].map((label) => (
              <div key={label} className="relative">
                <div className="rounded-[14px] border border-neutral-300 shadow-soft p-1">
                  <div className="rounded-[12px] bg-[#162e4d] text-center text-[15px] text-secondary-400 font-semibold px-4 py-5">
                    {label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    );
  }
  